import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaTruckMoving, FaTimes } from "react-icons/fa";
import { getLiveTrips, dismissLiveTrip } from "../../../redux/action/liveTrips";

const POLL_INTERVAL_MS = 20000;


function LiveTripsNotifications() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { trips, dismissed } = useSelector((state) => state.liveTrips);

  useEffect(() => {
    dispatch(getLiveTrips());
  
  }, [dispatch]);

  const visibleTrips = trips.filter((trip) => !dismissed.includes(trip._id));

  if (!visibleTrips.length) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 90,
        right: 24,
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        gap: 12,
        maxWidth: 340,
        width: "90%",
      }}
    >
      {visibleTrips.map((trip) => {
        const driver = trip.drivers?.[0];
        const fromName = trip.generator?.name || "Pickup location";
        const toName = trip.processor?.name || "Drop location";

        return (
          <div
            key={trip._id}
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: "14px 16px",
              boxShadow: "0 6px 24px rgba(0,0,0,0.15)",
              borderLeft: "4px solid #27AE60",
            }}
          >
            <div className="flex space-between align-center">
              <div className="flex align-center" style={{ gap: 8 }}>
                <span
                  style={{
                    display: "inline-flex",
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "#27AE60",
                    boxShadow: "0 0 0 4px rgba(39,174,96,0.18)",
                  }}
                />
                <span className="bold" style={{ fontSize: 13 }}>
                  Live trip in progress
                </span>
              </div>
              <FaTimes
                title="Dismiss"
                onClick={() => dispatch(dismissLiveTrip(trip._id))}
                style={{ cursor: "pointer", color: "#888" }}
              />
            </div>

            <div style={{ marginTop: 8, fontSize: 13, color: "#444" }}>
              <div className="flex align-center" style={{ gap: 6 }}>
                <FaTruckMoving style={{ color: "#27AE60" }} />
                <span>
                  {driver?.name ? `Driver: ${driver.name}` : "Driver en route"}
                </span>
              </div>
              <div style={{ marginTop: 4, color: "#777", fontSize: 12 }}>
                {fromName} → {toName}
              </div>
            </div>

            <div className="flex" style={{ gap: 8, marginTop: 12 }}>
              <button
                className="btn"
                style={{
                  flex: 1,
                  background: "#27AE60",
                  borderRadius: 8,
                  textTransform: "none",
                }}
                onClick={() => navigate(`/track-trip/${trip._id}`)}
              >
                Track Live
              </button>
              <button
                className="btn-flat"
                style={{
                  borderRadius: 8,
                  textTransform: "none",
                  color: "#888",
                }}
                onClick={() => dispatch(dismissLiveTrip(trip._id))}
              >
                Close
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default LiveTripsNotifications;
